const templateTranslations = window.vars ? window.vars.i18n : {};

export const translations = {
  template: {
    translations: {
      ...window.templatei18n,
      ...window.templateWidgeti18n,
      ...templateTranslations,
    },
  },
};
